/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Back_To_ResumeInputs */

const en_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to resume`)
};

const de_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Lebenslauf`)
};

const fr_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au CV`)
};

const es_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al CV`)
};

const it_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna al CV`)
};

const nl_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar CV`)
};

const pl_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do CV`)
};

const fi_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin ansioluetteloon`)
};

const da_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til CV`)
};

const sv_keyword_optimizer_back_to_resume = /** @type {(inputs: Keyword_Optimizer_Back_To_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till CV`)
};

/**
* | output |
* | --- |
* | "Back to resume" |
*
* @param {Keyword_Optimizer_Back_To_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_back_to_resume = /** @type {((inputs?: Keyword_Optimizer_Back_To_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Back_To_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_back_to_resume(inputs)
	if (locale === "fr") return fr_keyword_optimizer_back_to_resume(inputs)
	if (locale === "es") return es_keyword_optimizer_back_to_resume(inputs)
	if (locale === "it") return it_keyword_optimizer_back_to_resume(inputs)
	if (locale === "nl") return nl_keyword_optimizer_back_to_resume(inputs)
	if (locale === "pl") return pl_keyword_optimizer_back_to_resume(inputs)
	if (locale === "fi") return fi_keyword_optimizer_back_to_resume(inputs)
	if (locale === "da") return da_keyword_optimizer_back_to_resume(inputs)
	if (locale === "sv") return sv_keyword_optimizer_back_to_resume(inputs)
	return en_keyword_optimizer_back_to_resume(inputs)
});